export interface MaterialQuantity {
  code: string;
  quantity: number | null;
}

export const getTotalQuantity = (
  materials: { quantity: number | null }[]
): number =>
  materials.reduce((total, { quantity }) => total + (quantity ?? 0), 0);

export const getTotalWeight = (
  materials: MaterialQuantity[],
  standardWeightByCode: Record<string, number>
): number =>
  materials.reduce(
    (total, { code, quantity }) =>
      total + (quantity ?? 0) * (standardWeightByCode[code] ?? 0),
    0
  );

export const formatWeight = (weight: number): string =>
  weight.toLocaleString("en-US", { maximumFractionDigits: 2 });
